import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";

import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Subject } from "rxjs";

@Component({
  selector: "ngx-description-assignemnt",
  templateUrl: "./dynamic-input-form.component.html",
  styleUrls: ["./dynamic-input-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DescriptionAssignmentFormComponent extends BaseFormComponent<any> {
  formColumns: form_control[] = [];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.label = this.translate("ClientApp.FrontOffice.DriverAssignment.Description");
    this.apiName = "";
    this.areaName = "";
    super.ngOnInit();
  }

  addControl() {
    this.formColumns.forEach((x) => {
      this.setValue(x.name, null);
    });
    this.cd.markForCheck();
  }
  submitValue() {
    const inputValue = this.formGroup.value;
    this.result = inputValue?.UnAssignmentDesceription;
    this.close();
  }
  public cancel(): void {
    super.cancel();
  }
  async setColumns() {
    try {
      if (this.formColumns) {
        this.formColumns.forEach((x) => {
          x.tabOrder = 0;
        });
        if (this.detailName) {
          this.orignalColumns = this.formColumns.find((f) => f.name === this.detailName).DetailControlModels[this.detailName];
          this.columns = this.orignalColumns.filter(
            (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
          );
          this.columns = this.columns.sort((a, b) => a.order - b.order);
          this.setColumnAttribute();
          this.setColumnNumber(this.columns);
          this.setFormGroup(this.model[this.detailName]);
        } else {
          this.orignalColumns = this.formColumns;
          this.columns = this.formColumns.filter(
            (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
          );
          this.columns = this.columns.sort((a, b) => a.order - b.order);
          this.setColumnAttribute();
          this.setColumnNumber(this.columns);
          this.setFormGroup(this.model);
        }
        this.cd.markForCheck();
      }
    } catch (error) {
      this.getFailedHelper(error);
    }
  }
}
